import { render, staticRenderFns } from "./DashboardViewChat.vue?vue&type=template&id=6b5e30c2&"
import script from "./DashboardViewChat.vue?vue&type=script&lang=js&"
export * from "./DashboardViewChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports